document.addEventListener('DOMContentLoaded', () => {
	const categoryLinks = document.querySelectorAll('.menu-title a, .mobile-menu-item a');
	const mobileMenuItems = document.querySelectorAll('.mobile-menu-item');
	const secondaryMenuItems = document.querySelectorAll('.header__secondary-nav .category-link');

	// Check if we're in Shopify theme editor
	const isThemeEditor = window.Shopify && Shopify.designMode;

	// 26.10.2026: valinta tallennetaan noCategory-evästeeseen. Vanha selectedCategory-eväste sisälsi
	// automaattisen naiset-oletuksen, joten se nollataan kerran. Uudelle kävijälle ei enää tallenneta
	// oletusta: esivalinta tulee vain kävijän omasta valinnasta, tuotesivun SKU:sta tai tunnetusta
	// kohderyhmästä (window.NOAudience.applied, ks. snippets/audience-head.liquid).
	const STORAGE_KEY = 'noCategory';

	// Set cookie
	const setCookie = (name, value, days) => {
	  const expires = days
		? `; expires=${new Date(Date.now() + days * 86400000).toUTCString()}`
		: '';
	  document.cookie = `${name}=${value}; path=/${expires}`;
	};

	// Get cookie
	const getCookie = name =>
	  document.cookie
		.split(';')
		.map(c => c.trim())
		.find(c => c.startsWith(name + '='))?.substring(name.length + 1) || null;

	// Vanhan evästeen nollaus
	try {
	  if (getCookie('selectedCategory') !== null) {
		document.cookie = 'selectedCategory=; path=/; max-age=0';
	  }
	  if (isThemeEditor) localStorage.removeItem('selectedCategory');
	} catch (e) {}

	// 26.10.2026: 30 päivän eväste vain asetussuostumuksella, muuten istuntoeväste.
	const prefAllowed = () => {
	  try {
		return !!(window.NOAudience && typeof window.NOAudience.consentAllows === 'function' && window.NOAudience.consentAllows('preferences'));
	  } catch (e) { return false; }
	};

	// Helper functions to save and load the category from the proper storage
	const saveCategory = category => {
	  if (isThemeEditor) {
		localStorage.setItem(STORAGE_KEY, category);
	  } else {
		setCookie(STORAGE_KEY, category, prefAllowed() ? 30 : 0);
	  }
	};

	// Suostumus puuttuu tai on peruttu: muutetaan olemassa oleva eväste istuntoevästeeksi
	if (!isThemeEditor && !prefAllowed()) {
	  const existing = getCookie(STORAGE_KEY);
	  if (existing) setCookie(STORAGE_KEY, existing, 0);
	}

	const loadCategory = () =>
	  isThemeEditor ? localStorage.getItem(STORAGE_KEY) : getCookie(STORAGE_KEY);

	// Tunnetun kohderyhmän kategoria (ei tallenneta valinnaksi)
	const audienceCategory = () => {
	  const a = window.NOAudience && window.NOAudience.applied;
	  const c = a === 'women' ? 'naiset' : a === 'men' ? 'miehet' : null;
	  if (c && document.querySelector(`.category-group[data-category="${c}"], .category-group-mobile[data-category="${c}"]`)) return c;
	  return null;
	};

	/* DO NOT REFACTOR */
	// Anti-flickering function
	function filterDesktopCategories(selectedCategory) {
	  document.querySelectorAll('.category-group').forEach((group) => {
		let groupCategory = group.getAttribute('data-category');
		selectedCategory = isNaN(selectedCategory) ? selectedCategory : Number(selectedCategory);
		groupCategory = isNaN(groupCategory) ? groupCategory : Number(groupCategory);

		if (groupCategory == selectedCategory) {
			if (group.classList.contains('footer-category-group')) {
			  group.style.display = 'grid';
			} else {
			  group.style.display = 'flex';
			}
		  group.style.visibility = 'visible';
		  setTimeout(() => {
			group.style.opacity = '1'; // Fade in
		  }, 50);
		} else {
		  group.style.opacity = '0'; // Fade out
		  setTimeout(() => {
			group.style.display = 'none';
			group.style.visibility = 'hidden';
		  }, 100);
		}
	  });
	}

	// Ilman valintaa: ylävalikon alarivi pysyy tyhjänä, alatunnisteessa näytetään ensimmäinen ryhmä kuten ennenkin
	const showFooterDefault = () => {
	  const footerGroups = document.querySelectorAll('footer .category-group');
	  if (!footerGroups.length) return;
	  const first = footerGroups[0].getAttribute('data-category');
	  footerGroups.forEach(group => {
		if (group.getAttribute('data-category') === first) {
		  group.style.display = group.classList.contains('footer-category-group') ? 'grid' : '';
		} else {
		  group.style.display = 'none';
		}
	  });
	};

	const filterMobileCategories = selectedCategory => {
	  document.querySelectorAll('.category-group-mobile').forEach(group => {
		let groupCategory = group.getAttribute('data-category');
		selectedCategory = isNaN(selectedCategory) ? selectedCategory : Number(selectedCategory);
		groupCategory = isNaN(groupCategory) ? groupCategory : Number(groupCategory);
		group.style.display = groupCategory == selectedCategory ? 'grid' : 'none';
	  });
	};

	const highlightSelectedCategory = selectedCategory => {
	  mobileMenuItems.forEach(item =>
		item.classList.toggle('selected', item.getAttribute('data-menu') === selectedCategory)
	  );
	};

	const highlightSecondaryMenu = selectedCategory => {
	  secondaryMenuItems.forEach(item =>
		item.classList.toggle('selected', item.getAttribute('data-category') === selectedCategory)
	  );
	};

	// Näyttää kategorian tallentamatta sitä
	const applyCategory = selectedCategory => {
	  if (!selectedCategory) return;
	  filterDesktopCategories(selectedCategory);
	  filterMobileCategories(selectedCategory);
	  highlightSelectedCategory(selectedCategory);
	  highlightSecondaryMenu(selectedCategory);
	};

	// Kävijän oma valinta: tallennetaan ja näytetään
	const updateCategory = selectedCategory => {
	  if (!selectedCategory) return;
	  saveCategory(selectedCategory);
	  applyCategory(selectedCategory);
	};

	let savedCategory = loadCategory();

	if (typeof window.productSKU === 'string') {
	  const skuPrefix = window.productSKU.substring(0, 2).toUpperCase();
	  savedCategory = skuPrefix === 'N1' ? 'miehet' : skuPrefix === 'N2' ? 'naiset' : 'naiset';
	  saveCategory(savedCategory);
	}

	if (savedCategory) {
	  updateCategory(savedCategory);
	} else {
	  const audCategory = audienceCategory();
	  if (audCategory) {
		applyCategory(audCategory);
	  } else {
		showFooterDefault();
	  }
	}

	categoryLinks.forEach(categoryLink => {
	  categoryLink.addEventListener('click', event => {
		const selectedCategory = categoryLink.getAttribute('data-category');
		if (!selectedCategory) return;

		// If it's an anchor link (#), update immediately
		if (categoryLink.getAttribute('href') === '#') {
		  event.preventDefault();
		  updateCategory(selectedCategory);
		} else {
		  // For navigation links, save category but let navigation happen first
		  // The menu will update after the new page loads
		  saveCategory(selectedCategory);
		}
	  });
	});
  });